module.exports = __webpack_public_path__ + "media/images/flags/gh-080f2387b8ea5294a469e7ada4d3da8f.svg";